import { Box, Text } from "@prismicio/editor-ui"
import type { PropsWithChildren, ReactNode } from "react"

type SettingsPageBodySectionProps = PropsWithChildren<{
  title: ReactNode
  description: ReactNode
}>

export function SettingsPageBodySection(props: SettingsPageBodySectionProps) {
  const { title, description, children } = props
  return (
    <Box gap={120}>
      <Box flexDirection="column" gap={4} width={295}>
        <Text component="h4" variant="bold">
          {title}
        </Text>
        <Text color="grey11">{description}</Text>
      </Box>
      <Box flexDirection="column" flexGrow={1} flexBasis={0}>
        {children}
      </Box>
    </Box>
  )
}
